<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container" style="padding-bottom: 20px">
      <span class="page-title">角色列表</span>
      <div class="action-container">
        <a-button type="primary" icon="plus" @click="onCreateNew" class="page-title-btn">
          新建角色
        </a-button>
      </div>
    </div>
    <div class="content-container">
      <div class="list-container">
        <a-table
            :columns="tblColumns"
            :data-source="tblData"
            :pagination="false"
            :loading="loading"
        >
          <a-space slot="action" slot-scope="record">
            <a @click="onSetPrivileges(record)">权限设置</a>
            <a v-if="!record.sysDefinedInd" @click="onEdit(record)">编辑</a>
            <a v-if="!record.sysDefinedInd" @click="onDelete(record)" class="danger-text">删除</a>
          </a-space>
        </a-table>
      </div>
    </div>

    <a-modal
        :title="modalTitle"
        :visible="visible"
        :confirm-loading="confirmLoading"
        okText="确定"
        cancelText="取消"
        @ok="handleOk"
        @cancel="handleCancel"
    >
      <a-form :form="form" @submit="handleOk">
        <a-form-item
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
            label="角色名称"
        >
          <a-input
              v-decorator="[
                'roleName',
                {
                  rules: [{ required: true, message: '请输入角色名称' }]
                }
              ]"
          />
        </a-form-item>
        <a-form-item v-if="errMsg !== ''">
          <a-alert type="error" :message="errMsg" banner />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-layout>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { tsFormat } from "@/components/DateUtils";
import { fetchRoleList, saveRole, deleteRole } from "@/services/RoleService";

const tblColumns = [
  {
    title: "角色名称",
    dataIndex: "roleName",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" }
  }
];
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 12 }
};
export default {
  components: { Breadcrumb },
  data() {
    return {
      tblColumns,
      formItemLayout,
      tblData: [],
      loading: false,
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this, { name: "createRoleForm" }),
      errMsg: "",
      editMode: false,
      roleId: "",
    };
  },
  computed: {
    modalTitle() {
      if (this.editMode === false) {
        return "新增角色";
      } else {
        return "修改角色名称";
      }
    }
  },
  created() {

  },
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      fetchRoleList().then(response => {
        this.loading = false;
        if (response.data.code === "FAILED") {
          console.log("服务端错误", response.data.errorMsg);
          this.$message.error("读取数据失败");
        } else {
          this.setTblData(response);
        }
      });
    },
    setTblData(response) {
      let rltList = response.data.data;
      if (rltList) {
        rltList.forEach(item => {
          if (item.createTime) {
            item.createTime = tsFormat(item.createTime);
          }
        });
      }
      this.tblData = rltList;
    },
    onCreateNew() {
      this.editMode = false;
      this.visible = true;
      this.errMsg = "";
    },
    handleOk() {
      this.confirmLoading = true;
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.editMode) {
            this.executeModifyRole(values);
          } else {
            this.executeCreateRole(values);
          }
        }
      });
    },
    //执行创建角色
    executeCreateRole(values) {
      saveRole(values).then(response => {
        if (response.data.code === "SUCCESS") {
          this.visible = false;
          this.confirmLoading = false;
          this.setTblData(response);
          this.form.resetFields();
          this.errMsg = "";
          this.$message.success("添加成功");
          this.fetchList();
        } else {
          this.confirmLoading = false;X
          this.errMsg = response.data.errorMsg;
        }
      })
      .catch(error => {
        this.visible = false;
        this.confirmLoading = false;
        console.log(error);
      });
    },
    //执行修改角色名称
    executeModifyRole(values) {
      values.sysRoleId = this.roleId;
      saveRole(values).then(response => {
        if (response.data.code === "SUCCESS") {
          this.visible = false;
          this.confirmLoading = false;
          this.form.resetFields();
          this.errMsg = "";
          this.$message.success("修改成功");
          this.fetchList();
        } else {
          this.confirmLoading = false;
          this.errMsg = response.data.errorMsg;
        }
      })
      .catch(error => {
        this.visible = false;
        this.confirmLoading = false;
        console.log(error);
      });
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
    },
    onEdit(record) {
      this.editMode = true;
      this.visible = true;
      this.errMsg = "";
      this.roleId = record.sysRoleId;
      this.$nextTick(() => {
        this.form.setFieldsValue({ roleName: record.roleName });
      });
    },
    onDelete(record) {
      let that = this;
      this.$confirm({
        title: `确定要删除【${record.roleName}】角色吗?`,
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          deleteRole(record.sysRoleId).then(resp => {
            if (resp.data.code === "SUCCESS") {
              that.$message.success("删除成功");
              that.fetchList();
            } else {
              that.$message.error("删除失败:" + resp.data.errorMsg);
            }
          });
        }
      });
    },
    onSetPrivileges(record) {
      console.log("onSetPrivileges", record);
      this.$router.push({
        name: "SetPrivilege",
        params: { id: record.sysRoleId }
      });
    }

  }
};
</script>

<style scoped>
.desc-text {
  font-size: 12px;
  color: #999999;
}
</style>
